<template>
  <el-form
    ref="addFrom"
    :model="addFrom"
    :rules="rules"
    label-width="120px"
    class="userManage-from"
  >
    <el-row>
      <el-col :span="24">
        <el-form-item label="字段名" prop="ename">
          <el-input v-model="addFrom.ename"> </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-form-item label="字段中文名" prop="cname">
          <el-input v-model="addFrom.cname"> </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-form-item label="字段类型" prop="type">
          <el-select
            ref="type"
            v-model="addFrom.type"
            filterable
            size="small"
            style="width: 200px"
            class="filter-item"
          >
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div v-show="addFrom.type == 1">
          <el-form-item label="字段默认值" prop="defaultValue">
            <el-input
              v-model="addFrom.defaultValue"
              type="textarea"
              :rows="3"
              placeholder="请输入内容"
              show-word-limit
              maxlength="200"
            >
            </el-input>
          </el-form-item>
        </div>
        <div v-show="addFrom.type == 2">
          <div>
            <div id="wangEditor"></div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <!-- <el-col :span="12">
          <el-form-item label="系统默认字段：" prop="def">
            <el-switch
            v-model="addFrom.def"
            active-value="1"
            inactive-value="0"
            disabled:disabled>
            </el-switch>
          </el-form-item>
        </el-col> -->
      <el-col :span="12">
        <el-form-item label="是否必填：" prop="required">
          <el-switch
            v-model="addFrom.required"
            active-value="1"
            inactive-value="0"
          >
          </el-switch>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="占据列数：" prop="span">
          <el-input-number
            v-model="addFrom.span"
            controls-position="right"
            :min="1"
            :max="10"
            size="small"
          ></el-input-number>
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="排序：" prop="px">
          <el-input-number
            v-model="addFrom.px"
            controls-position="right"
            :min="1"
            :max="10"
            size="small"
          ></el-input-number>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import wangEditor from "wangeditor";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters } from "vuex";
import { saveProp } from "@/api/meta.js";

export default {
  name: "add",
  components: { Treeselect },
  props: ["mxParams"],
  data() {
    return {
      addFrom: {},
      typeOptions: [
        { value: "1", label: "输入框" },
        { value: "2", label: "富文本框" },
      ],

      rules: {
        ename: [{ required: true, message: "字段名不能为空", trigger: "blur" }],
        cname: [
          { required: true, message: "字段中文名不能为空", trigger: "blur" },
        ],
        type: [
          { required: true, message: "字段类型不能为空", trigger: "change" },
        ],
      },
    };
  },
  created() {},
  mounted() {
    let editor = new wangEditor(`#wangEditor`);
    editor = this.editorConfig(editor);
    this.editor = editor;
  },
  methods: {
    editorConfig(editor) {
      editor.config.placeholder = "请输入内容";
      editor.config.height = 300;
      //editor.config.uploadImgShowBase64 = true
      editor.config.uploadImgMaxSize = 10 * 1024 * 1024; //图片大小10M
      editor.config.uploadImgMaxLength = 1;
      editor.config.uploadFileName = "file"; //上传参数 自定义
      editor.config.uploadImgTimeout = 60000; //60s
      editor.config.uploadImgServer = window.g.apiUrl + "/system/uploadPicFile";
      editor.config.uploadImgHeaders = {
        "x-token": localStorage.getItem("token"), // 设置请求头
      };
      editor.config.uploadImgHooks = {
        //监听
        timeout: function (xhr, editor) {
          this.$message.error("上传图片超时！");
        },
        customInsert: function (insertImg, result, editor) {
          if (result.code == 0) {
            var url = result.msg;
            insertImg(url);
          }
        },
      };
      editor.config.excludeMenus = ["video", "link", "code"];
      // 配置 onchange 回调函数，将数据同步到 vue 中
      // editor.config.onchange = function() {
      //   if (editor.txt.html() == "") {
      //     editor.txt.html("&nbsp");
      //   }
      // };

      editor.create();
      return editor;
    },

    saveForm() {
      this.$refs["addFrom"].validate((valid) => {
        if (valid) {
          this.addFrom.metaId = this.$route.params.metaId;
          if (this.addFrom.type == 2) {
            this.addFrom.defaultValue = this.editor.txt.html();
          }
          saveProp(this.addFrom).then((res) => {
            if (res.code == 0) {
              this.$message.success(res.msg);
              this.$emit("getParentForm");
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.star {
  position: absolute;
  top: 13px;
  color: #f56c6c;
  left: 55px;
}
.table {
  .table-header {
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #f2f2f2;
    display: flex;
    justify-content: center;
    > div {
      width: 20%;
      display: flex;
      justify-content: center;
      > div {
        color: #036eb8;
        padding: 0 10px;
        font-size: 25px;
        cursor: pointer;
      }
    }
    > div:nth-of-type(2) {
      width: 40%;
    }
  }
  .table-none {
    text-align: center;
    color: #999;
    margin: 10px 0;
  }
  .table-body {
    .table-tr {
      display: flex;
      height: 44px;
      line-height: 44px;
      text-align: center;
      display: flex;
      justify-content: center;
      border-bottom: 1px solid #f2f2f2;
      // border-left: 1px solid #f2f2f2;
      .table-td {
        display: flex;
        justify-content: center;
        width: 20%;
        // border-right: 1px solid #f2f2f2;
      }
      .table-td:nth-of-type(2) {
        width: 40%;
      }
      .del {
        color: #ff0000;
        cursor: pointer;
      }
    }
  }
}
</style>